export const PURCHASE_SUCCESS_MESSAGE = "Your purchase was successful";
export const PURCHASE_PROCESSING_MESSAGE = "Your purchase is being processed...";
export const PURCHASE_ERROR_MESSAGE = "Something went wrong";
